import { toast } from 'react-toastify'
import { ky } from './client'

/**
 * Marks an audit archived.
 *
 * @param {String} assignmentId - the assignment UUID.
 * @returns
 */
export const archiveAudit = async (assignmentId) => {
  const request = await ky.delete(`audit/${assignmentId}`, {
    showErrorToast: true,
    customErrorMessage: 'Something went wrong when deleting this audit.',
    showSuccessToast: true,
    customSuccessMessage: 'Audit deleted successfully.'
  })
  return await request.json()
}

/**
 * Marks an audit archived.
 *
 * @param {String} auditId- the audit UUID.
 * @returns
 */
export const deleteAudit = async (auditId) => {
  await ky.delete(`audit/delete/${auditId}`, {
    showErrorToast: true,
    customErrorMessage: 'Deletion failed'
  })
}

/**
 * Reopens a completed assignment and review.
 *
 * @param {String} assignmentId - the assignment UUID.
 * @returns
 */
export const reopenAssignment = async (assignmentId) => {
  const request = await ky.get(`audit/reopen/${assignmentId}`, {
    showErrorToast: true,
    customErrorMessage: 'Something went wrong when reopening this audit.',
    showSuccessToast: true,
    customSuccessMessage: 'Successfully reopened audit.'
  })
  return await request.json()
}

/**
 * Fetches the reviews list.
 *
 * @param {Object} pagination - Pagination details.
 * @param {string} pagination.search - An email/name search string.
 * @param {number} pagination.pageNumber - Page number.
 * @param {number} pagination.pageSize - Page size.
 *
 * @returns
 */
export const getReviewList = async (pagination) => {
  try {
    const request = await ky.get('audit/all', {
      searchParams: pagination
    })
    return await request.json()
  } catch (error) {
    console.error(error)
    toast('Unable to view reviews. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: []
    }
  }
}

export const getLiveAuditList = async (pagination) => {
  try {
    const request = await ky.get('audit/live', {
      searchParams: pagination
    })
    return await request.json()
  } catch (error) {
    console.error(error)
    toast('Unable to retrieve live audits. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: []
    }
  }
}

export async function downloadReviewExport(reviewId) {
  try {
    const pdfRes = await ky.get(`reviews/export/${reviewId}`)
    if (!pdfRes) {
      throw new Error('not data found')
    }
    const blob = await pdfRes.blob()
    const fileURL = window.URL.createObjectURL(blob)
    window.open(fileURL, '_blank').focus()
  } catch (e) {
    console.error(e)
    toast('Unable to retrieve audit. Please try again later.', {
      type: 'warning'
    })
    console.error(e)
  }
}

export function useThemes(auditTypeId) {
  // if (auditTypeId)
  return {}
}
